/** Meeting-room charging, as the member portal shows it. The helpers live in @nodus/booking so the
 *  portal, the shared booking components and the kiosk word prices the same way. */

export {
  estimateCharge,
  estimateNote,
  formatKr,
  hasPriceInfo,
  lateCancelNote,
  priceBadgeText,
  pricingOn,
  pricingTerms,
} from "@nodus/booking";
export type { RoomPricing } from "@nodus/booking";

import { estimateCharge, formatKr, type RoomPricing } from "@nodus/booking";

/** The money line of a booking in "My bookings": what it was charged (``charge_sek``, the booking's
 *  active charges) or, before a charge exists, the estimate. ``null`` for a free booking. */
export function bookingChargeText(booking: {
  start: string;
  end: string;
  pricing?: RoomPricing | null;
  charge_sek?: number | null;
}): string | null {
  if (booking.charge_sek != null && booking.charge_sek > 0) {
    return `Charged ${formatKr(booking.charge_sek)} kr excl. VAT`;
  }
  const estimate = estimateCharge(booking.pricing, booking.start, booking.end);
  if (!estimate) return null;
  return `${estimate.upTo ? "Up to" : "Estimated"} ${formatKr(estimate.amount)} kr excl. VAT`;
}
